import { ISaveEventCourseItemHistoryModel } from "../models/dto/ZoomiLxp/Models/EventModels/ISaveEventCourseItemHistoryModel";
import { EventTypes } from "models/dto/ZoomiLxp/Utilities/Enumerations/EventTypes";
import { useAppStore } from "store";

export const useScormNav = (prev: () => void, next: () => void) => {
	const { contentStore, toasterStore, coursesStore } = useAppStore();
	const handleNext = async () => {
		const data: ISaveEventCourseItemHistoryModel = {
			sessionId: contentStore?.sessionId ?? 0,
			eventType: EventTypes.Complete,
			payload: "",
		};
		coursesStore.updateActiveCourseItemToCompleted();
		contentStore.stopKeepAlive();
		contentStore
			.sendEventCourseItemHistory(data)
			.then(() => next())
			.catch((err) => toasterStore.showErrorMessage(err));
	};

	const handlePrev = async () => {
		const data: ISaveEventCourseItemHistoryModel = {
			sessionId: contentStore?.sessionId ?? 0,
			eventType: EventTypes.Complete,
			payload: "",
		};
		coursesStore.updateActiveCourseItemToCompleted();
		contentStore.stopKeepAlive();
		contentStore
			.sendEventCourseItemHistory(data)
			.then(() => prev())
			.catch((err) => toasterStore.showErrorMessage(err));
	};

	return { handleNext, handlePrev };
};
